import { UserActionTypes, UserType, SET_USER } from '../../types/CustomerTypes';

export function setUser(user: UserType): UserActionTypes {
  return {
    type: SET_USER,
    payload: user,
  };
}
